import { gql, TypedDocumentNode } from '@apollo/client'
import { UnauthorizedError, ForbiddenError, ResourceNotFoundError } from '../errorTypes'

export interface ChangeCompanySuccess
  extends Readonly<{
    __typename: 'ChangeCompanySuccess'
    accessToken: string
    refreshToken: string
    locationToken: string
  }> {}

export interface ChangeCompanyResponse {
  changeCompany: ChangeCompanySuccess | UnauthorizedError | ForbiddenError | ResourceNotFoundError
}

export interface ChangeCompanyVariables {
  companyId: number
}

export const CHANGE_COMPANY: TypedDocumentNode<ChangeCompanyResponse, ChangeCompanyVariables> = gql`
  mutation ChangeCompany($companyId: Int!) {
    changeCompany(companyId: $companyId) {
      __typename
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
      ... on ForbiddenError {
        error {
          code
          message
          details
          context
        }
      }
      ... on ResourceNotFoundError {
        error {
          code
          message
          details
          context
        }
      }
      ... on ChangeCompanySuccess {
        accessToken
        refreshToken
        locationToken
      }
    }
  }
`
